var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m177.02 282.883 51.37-52.118H29.748v-64.528h98.182c54 0 98.181-1.635 98.181-3.634s-21.497-25.452-47.771-52.118L130.568 62h88.311l67.435 68.316 67.436 68.316-67.565 68.185-67.565 68.185h-92.97z"
  })));
};
export default SvgArrow;